// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import Tree, { TreeNode } from 'rc-tree'
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { colors } from 'catena/er2_styles'
import PropStyles from 'catena/er2_styles/layer_properties'
import type { SitesType } from '../reducers/public_sites'
import type { MapsourcesType } from '../reducers/mapsources'

const toolbarMinHeight = '44px'
const styles = (theme) => ({
    root: {
        fontFamily: '\'Roboto Condensed\', sans-serif',
        // fontSize: 'smaller',
    },
    box: {
        backgroundColor: 'white',
        position: 'absolute',
        zIndex: '200',
        borderRadius: '5px 0px 0px 5px',
        borderLeft: '1px solid #888',
        borderTop: '1px solid #888',
        borderBottom: '1px solid #888',
    },
    button: {
        backgroundColor: 'initial',
    },
    closeButton: {
        margin: '10px',
        float: 'right',
    },
    muitoolbarRoot: {
        color: colors.white,
        minHeight: toolbarMinHeight,
        '@media': {
            minHeight: toolbarMinHeight,
        },
    },
    muitypographtTitle: {
        fontSize: '16px',
        fontWeight: 700,
    },
    tabLabel: {
        fontSize: 'large',
    },
})

type PropTypes = {
    baseImageURL: string,
    getPublicSites: Function,
    mapsources: MapsourcesType,
    onClose: Function,
    onSelect: Function,
    pos: {
        right: number,
        top: number,
    },
    publicSites: SitesType,
    theme: PropStyles,
}

class PublicDataChooser extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.state = {
            defaultExpandedKeys: [],
            defaultSelectedKeys: [],
            defaultCheckedKeys: [],
        }
    }

    componentDidMount() {
        this.getPublicSites()
    }

    getPublicSites() {
        this.props.getPublicSites()
    }

    render() {
        const currentServices = this.props.mapsources.mapsources.filter(m => m.type === 'arcgisrest').map(m => m.service_name)
        const buildTreeData = () => this.props.publicSites.sites.map(site => (
            <TreeNode
                key={site.name}
                className={this.props.classes.root}
                title={(<span>{site.title || site.name}</span>)}
                type={'site'}
            >
                {site.services && site.services.map((service) => {
                    const ready = service.layers !== undefined
                    const alreadyAdded = currentServices.indexOf(service.name) >= 0
                    const addSite = () => this.props.onSelect([{ site, service }])
                    const addButton = (
                        <span>
                            <a onClick={addSite} target="node" role="button" tabIndex={-1}
                                style={{ marginLeft: '10px' }}>
                                <i className={'fa fa-plus-circle'} />
                            </a>
                        </span>
                    )
                    const waitIcon = (
                        <img
                            alt="loading service info"
                            style={{ marginLeft: '4px' }}
                            src={'/static/er2_map/img/loading.gif'}
                        />
                    )
                    return (
                        <TreeNode
                            key={service.name}
                            className={this.props.classes.root}
                            service={service}
                            site={site}
                            title={(<span style={{ color: !alreadyAdded || 'gray' }}>
                                {service.title || service.name}
                                {!alreadyAdded && !ready && waitIcon}
                                {!alreadyAdded && ready && addButton}
                            </span>)}
                            type={'service'}
                        >
                            {false && service.layers && service.layers.map(layer => (
                                <TreeNode
                                    key={layer.id}
                                    title={(<span>{layer.name}</span>)}
                                    type={'layer'}
                                />
                            ))}
                        </TreeNode>
                    )
                })}
            </TreeNode>
        ))

        const onSelect = (selectedKeys, info) => {
        }

        const onCheck = (checkedKeys, info) => {
            const servicesToAdd = []
            info.checkedNodes.forEach((node) => {
                if (node.props.type === 'service') {
                    servicesToAdd.push({ site: node.props.site, service: node.props.service })
                }
            })
            this.props.onSelect(servicesToAdd)
        }

        return (
            <div
                className={this.props.classes.box}
                style={{
                    right: this.props.pos.right,
                    top: this.props.pos.top,
                }}
            >
                <AppBar
                    color="secondary"
                    position="static"
                >
                    <Tabs value={0}>
                        <Tab classes={{ label: this.props.classes.tabLabel }} label="Map Services" />
                    </Tabs>
                </AppBar>
                <Tree
                    defaultExpandAll
                    defaultExpandedKeys={this.state.defaultExpandedKeys}
                    onExpand={this.onExpand}
                    defaultSelectedKeys={this.state.defaultSelectedKeys}
                    defaultCheckedKeys={this.state.defaultCheckedKeys}
                    onSelect={onSelect}
                    onCheck={onCheck}
                    selectable={false}
                    showIcon={false}
                >
                    {buildTreeData()}
                </Tree>
                <div>
                    <span style={{ display: 'inline-block', height: '30px' }}>&nbsp;</span>
                    <Button
                        classes={{
                            contained: this.props.classes.button,
                        }}
                        className={this.props.classes.closeButton}
                        color="primary"
                        onClick={() => this.props.onClose()}
                    >
                        Close
                    </Button>
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(PublicDataChooser)
